import { css } from '@emotion/react'
import { Divider } from '@mui/material'
import { motion } from 'framer-motion'
import { createPortal } from 'react-dom'
import { Column } from '@datasets/handsontable/read-grid/cell-renderers/readGridDataCell/types'
import { isElementOutOfViewport } from '@utils/isElementOutOfViewport'
import { Container, MODAL_HEIGHT, fadeInAnimationVariants, getBaseModalCss } from './styles'
import { t } from '@lingui/core/macro'

const defaultText = css`
  font-size: 12px;
  font-weight: 700;
  color: #2e196b;
  margin: 0;
  text-transform: capitalize;
`

const sectionDescription = css`
  font-size: 11px;
  color: #2e196b66;
  margin: 0;
`

const classificationTitle = css`
  font-size: 14px;
  font-weight: 700;
  color: #a79ebe;
  margin: 0;
  margin-bottom: 5px;
`

const textContainer = css`
  padding: 14px 18px;
  text-align: left;
  text-transform: capitalize;
`

interface AiClassificationsOverlayProps {
  top: number
  bottom: number
  left: number
  container?: HTMLElement
  classificationColumnsWithValues: Column[]
}

export const AiClassificationsOverlay = ({
  top,
  bottom,
  left,
  container = document.body,
  classificationColumnsWithValues,
}: AiClassificationsOverlayProps) => {
  const shouldModalOpenUp = isElementOutOfViewport({
    innerElementHeight: MODAL_HEIGHT,
    top,
    bottom,
  })

  const topPosition = shouldModalOpenUp ? bottom - 54 - MODAL_HEIGHT : bottom

  return createPortal(
    <motion.div
      variants={fadeInAnimationVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      css={css`
        top: ${topPosition}px;
        left: ${left}px;
        ${getBaseModalCss(shouldModalOpenUp)}
      `}
    >
      <Container>
        <div css={textContainer}>
          <p css={defaultText}>{t`Generated labeling / classification`}</p>
          <p css={sectionDescription}>Powered by Claravine AI</p>
        </div>
        {classificationColumnsWithValues.map((column: any) => {
          return (
            <>
              <Divider sx={{ width: '100%' }} />
              <div css={textContainer}>
                <h3 css={classificationTitle}>{column.name}</h3>
                {column.values.map((value, index) => (
                  <p css={defaultText} key={`${value}-${index}`}>
                    {value}
                  </p>
                ))}
              </div>
            </>
          )
        })}
      </Container>
    </motion.div>,
    container,
  )
}
